export const DEFAULT_PAGE_PATH = '/d/:slug';

export const EMBED_PAGE_PATH = '/d/:id';
